import { render, staticRenderFns } from "./EmployerName.vue?vue&type=template&id=027ed493"
import script from "./EmployerName.vue?vue&type=script&lang=js"
export * from "./EmployerName.vue?vue&type=script&lang=js"
import style0 from "./EmployerName.vue?vue&type=style&index=0&id=027ed493&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports